import React, { useEffect, useState } from 'react'

import { styled } from '@mui/material'
import { onboardingState } from '../../../context/onboarding-context'
import HeaderCloseableFlow from '../header-closeable-flow'
import { HBox } from '../../../elements/basic-elements'
import { colors } from '../../../constants/colors'
import {
  RedirectReason,
  OnboardingStep,
  OnboardingStepState
} from '../../../types/onboarding-types'
import { capitalizeFirstLetter } from '../../../utilities/string'
import HeaderOnboardingStep from './header-onboarding-step'
import { navigate } from 'gatsby'
import { authState } from '../../../state/auth-state'

export const HEADER_ONBOARDING_STEPS = [
  OnboardingStep.VERBS,
  OnboardingStep.NOUNS,
  OnboardingStep.COBENEFITS,
  OnboardingStep.SKILLS,
  OnboardingStep.LOCATION,
  OnboardingStep.MEMBERSHIP,
  OnboardingStep.VERIFICATION
]

const OnboardingStepLabels = {
  [OnboardingStep.VERBS]: 'Verbs',
  [OnboardingStep.NOUNS]: 'Nouns',
  [OnboardingStep.COBENEFITS]: 'Co-benefits',
  [OnboardingStep.SKILLS]: 'Skills',
  [OnboardingStep.LOCATION]: 'Location',
  [OnboardingStep.MEMBERSHIP]: 'Membership',
  [OnboardingStep.VERIFICATION]: 'Verification'
}

export const ONBOARDING_HEADER_MOBILE_BREAKPOINT = 1040

const HeaderOnboarding = () => {
  const { account } = authState()
  const { currentStep } = onboardingState()
  const currentStepNumber = HEADER_ONBOARDING_STEPS.findIndex(option => currentStep === option)
  const showOnboardingStepper = currentStep != null && currentStep !== OnboardingStep.INTRO

  const [furthestStep, setFurthestStep] = useState(currentStepNumber)
  useEffect(() => {
    if (currentStepNumber > furthestStep) {
      setFurthestStep(currentStepNumber)
    }
  }, [currentStepNumber])

  return (
    <HeaderCloseableFlow
      onClose={() => {
        navigate(
          account?.premium_access && account?.user_id ? `/profile/${account?.user_id}` : '/',
          {
            state: { redirectReason: RedirectReason.EXITED_ONBOARDING }
          }
        )
      }}
    >
      <HBox overflow="auto" justifyContent="center" paddingTop={1}>
        {showOnboardingStepper && (
          <StepperContainer>
            {HEADER_ONBOARDING_STEPS.map(stepOption => {
              const stepOptionNumber = HEADER_ONBOARDING_STEPS.findIndex(
                option => stepOption === option
              )
              const stepState =
                currentStep === stepOption
                  ? OnboardingStepState.IN_PROGRESS
                  : stepOptionNumber === furthestStep
                    ? OnboardingStepState.STARTED
                    : stepOptionNumber < currentStepNumber
                      ? OnboardingStepState.COMPLETED
                      : OnboardingStepState.NOT_STARTED

              return (
                <HeaderOnboardingStep
                  key={`onboarding-step-${stepOptionNumber}`}
                  disabled={currentStep === stepOption || stepOptionNumber > furthestStep}
                  stepState={stepState}
                  stepNumber={stepOptionNumber}
                  stepLabel={capitalizeFirstLetter(OnboardingStepLabels[stepOption])}
                />
              )
            })}
          </StepperContainer>
        )}
      </HBox>
    </HeaderCloseableFlow>
  )
}

const StepperContainer = styled(HBox)`
  ${({ theme }) => `
    background-color: ${theme.palette.mode === 'dark' ? colors.DARK_MODE_70 : colors.WHITE};
    padding: 10px 20px;
    border-radius: 30px;
    align-items: center;
    justify-content: center;
    ${theme.breakpoints.down(ONBOARDING_HEADER_MOBILE_BREAKPOINT)} {
      background-color: unset;
      gap: 8px;
      padding: 0px;
    }
  `}
`

export default HeaderOnboarding
